import React from 'react';
import { Modal, ModalBody, Button, Alert, Input, FormGroup, Label } from 'reactstrap';

class DeleteAccountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { stage: 1, confirmText: '' };
  }

  handleClose = () => {
    const { onClose } = this.props;
    this.setState({ stage: 1, confirmText: '' });
    onClose();
  };

  handleConfirm = () => {
    const { onDelete } = this.props;
    const { confirmText } = this.state;
    if (confirmText.toUpperCase() === 'DELETE') {
      onDelete();
      this.setState({ stage: 1, confirmText: '' });
    }
  };

  render() {
    const { isOpen } = this.props;
    const { stage, confirmText } = this.state;
    const canConfirm = confirmText.toUpperCase() === 'DELETE';

    return (
      <Modal isOpen={isOpen} toggle={this.handleClose}>
        <ModalBody className="p-4">
          {stage === 1 ? (
            <div>
              <h5 className="mb-3">What happens when I delete my account?</h5>
              <p className="text-muted small mb-3">
                Deleting your account will remove your subscription and information from our
                system. If you proceed you will no longer be able to log into the Macrostax app.
              </p>
              <ul className="text-muted small mb-4" style={{ paddingLeft: '1.25rem' }}>
                <li className="mb-2">
                  You understand that deleting your account is final and non-reversible.
                </li>
                <li className="mb-2">
                  You understand that deleting your account will revoke your app access
                  immediately.
                </li>
              </ul>
              <Button color="danger" size="lg" block className="mb-3" onClick={() => this.setState({ stage: 2 })}>
                Delete my account
              </Button>
              <Button outline color="primary" size="lg" block onClick={this.handleClose}>
                Never mind
              </Button>
            </div>
          ) : (
            <div>
              <h5 className="mb-3">Confirm account deletion</h5>
              <p className="text-muted small mb-3">
                This action is final and non-reversible. Your app access will be revoked
                immediately.
              </p>
              <FormGroup>
                <Label className="small">Type <strong>DELETE</strong> to confirm</Label>
                <Input
                  type="text"
                  value={confirmText}
                  onChange={(e) => this.setState({ confirmText: e.target.value })}
                  placeholder="DELETE"
                />
              </FormGroup>
              <Button
                color="danger"
                size="lg"
                block
                className="mb-3"
                onClick={this.handleConfirm}
                disabled={!canConfirm}
              >
                Delete my account
              </Button>
              <Button outline color="primary" size="lg" block onClick={this.handleClose}>
                Never mind
              </Button>
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default DeleteAccountModal;
